import SignUp from 'components/pages/SignUp/SignUp';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('registration-login');

export default buildPage(SignUp, {
  skipSSR: true,
  metaData: {
    title: 'Registration',
    description: 'Please log in or sign up',
  },
  loggedInRedirect: '/dashboard',
});
